module.exports = __webpack_public_path__ + "fonts/Roboto-Black.72f6fd21.woff2";